// extracted by mini-css-extract-plugin
export var addToCartButton = "_oq-b";
export var arrowButtonContainer = "_oq-9";
export var arrowButtonIcon = "_oq-a";
export var carouselArrowButton = "_oq-6";
export var carouselElementContainer = "_oq-1";
export var galleryThumbnail = "_oq-d";
export var galleryThumbnailImage = "_oq-e";
export var left = "_oq-7";
export var productDisplayCarouselContainer = "_oq-0";
export var productTileContainer = "_oq-2";
export var productTileImage = "_oq-4";
export var productTileImageContainer = "_oq-3";
export var productTileTitle = "_oq-5";
export var right = "_oq-8";
export var sliderOverflow = "_oq-c";